import horizontalScrollTheme from './horizontalScrollTheme';
var horizontalScrollDarkTheme = {
  horizontalScroll: Object.assign({}, horizontalScrollTheme.horizontalScroll, {
    fadeColor: '#0c0c0c'
  })
};
export default horizontalScrollDarkTheme;